import { forwardRef, useId } from 'react'
import { cn } from './cn'

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
	label?: React.ReactNode
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
	{ label, className, id, ...rest },
	ref,
) {
	const generatedId = useId()
	const radioId = id ?? generatedId
	const control = (
		<input
			ref={ref}
			id={radioId}
			type="radio"
			className={cn('radio-refined', className)}
			{...rest}
		/>
	)
	if (label == null) return control
	return (
		<label htmlFor={radioId} className="inline-flex items-center gap-2 cursor-pointer text-sm">
			{control}
			<span>{label}</span>
		</label>
	)
})
